import type { Data } from "convert";
import convert from "convert";
import prettyBytes from "pretty-bytes";

export class Bytes {
  public readonly value: number;

  public constructor(bytes: number) {
    this.value = bytes;
  }

  public static of(amount: number, unit: Data): Bytes {
    return new Bytes(convert(amount, unit).to("bytes"));
  }

  public add(other: Bytes): Bytes {
    return new Bytes(this.value + other.value);
  }

  public multiply(by: number): Bytes {
    return new Bytes(this.value * by);
  }

  public text(): string {
    return prettyBytes(this.value, {
      locale: "de",
      binary: true,
    }).replace("i", "");
  }

  public textIn(unit: Data, digits?: number): string {
    const converted = convert(this.value, "bytes").to(unit);
    return `${converted.toFixed(digits).replace(".", ",")} ${unit.replace("i", "")}`;
  }

  public isGreaterThan(other: Bytes): boolean {
    return this.value > other.value;
  }

  public in(unit: Data, digits?: number): number {
    const converted = convert(this.value, "bytes").to(unit);
    if (!digits) {
      return converted;
    }
    return Math.round(converted * 10 ** digits) / 10 ** digits;
  }
}
